import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import common_es from '../lang/es/translation.json';
import common_en from '../lang/en/translation.json';

// the translations
const resources = {
  es: common_es,
  en: common_en
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'es',
    keySeparator: '.',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
